import { ANALYTICS_EVENTS, analytics, type ActorT } from '@/shared/lib';
import {
  $patientPanelSelectedTab,
  setPatientPanelSelectedTab,
  type PatientPanelTabId,
} from '@/shared/stores';

export interface SelectPatientPanelTabOptions {
  actor: ActorT;
  patientUserId: string;
}

/**
 * Single entry point for changing the active workspace tab.
 *
 * Every caller — clinician header click, global search hit selection,
 * copilot button tool — routes through here so `workspace.tab.focused`
 * analytics is emitted exactly once per real transition with consistent
 * `actor` attribution.
 */
export function selectPatientPanelTab(
  tabId: PatientPanelTabId,
  options: SelectPatientPanelTabOptions
): void {
  const previousTabId = $patientPanelSelectedTab.get();
  setPatientPanelSelectedTab(tabId);
  if (previousTabId === tabId) return;

  void analytics.track({
    name: ANALYTICS_EVENTS.workspace.tabFocused,
    context: {
      actor: options.actor,
      patientUserId: options.patientUserId,
    },
    properties: {
      tabId,
      fromTabId: previousTabId ?? undefined,
    },
  });
}
